/** In milliseconds */
export const SECOND = 1000;
/** In milliseconds */
export const SECONDS = SECOND;

/** In milliseconds */
export const MINUTE = 60 * SECOND;
/** In milliseconds */
export const MINUTES = MINUTE;

/** In milliseconds */
export const HOUR = 60 * MINUTE;
/** In milliseconds */
export const HOURS = HOUR;

/** In milliseconds */
export const DAY = 24 * HOUR;
/** In milliseconds */
export const DAYS = DAY;
